var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#000064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.65 35V24.499h2.958L30 20.88h-3.35l.005-1.811c0-.944.091-1.45 1.475-1.45h1.85V14h-2.96c-3.554 0-4.805 1.755-4.805 4.708v2.172H20v3.62h2.215V35h4.435z",
    fill: "#000064"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCgk8Y2lyY2xlIGN4PSIyNSIgY3k9IjI1IiByPSIyNC41IiBzdHJva2U9IiMwMDAwNjQiLz4NCgk8cGF0aCBkPSJNMjYuNjQ5NiAzNVYyNC40OTg4SDI5LjYwNzlMMzAgMjAuODhIMjYuNjQ5NkwyNi42NTQ2IDE5LjA2ODhDMjYuNjU0NiAxOC4xMjQ5IDI2Ljc0NjEgMTcuNjE5MiAyOC4xMjk2IDE3LjYxOTJIMjkuOTc5MVYxNEgyNy4wMjAzQzIzLjQ2NjMgMTQgMjIuMjE1MyAxNS43NTU1IDIyLjIxNTMgMTguNzA3N1YyMC44ODA0SDIwVjI0LjQ5OTJIMjIuMjE1M1YzNUgyNi42NDk2WiIgZmlsbD0iIzAwMDA2NCIvPg0KPC9zdmc+";
export { SvgIconShareFb as ReactComponent };